import React from 'react'

export const Heart: React.FC = () => {
  return (
    <path
      d="M8 14.8642C8.14286 14.8642 8.28572 14.8106 8.39286 14.7035L13.9554 9.34633C14.0357 9.26597 16 7.47133 16 5.32847C16 2.7124 14.4018 1.1499 11.7321 1.1499C10.1696 1.1499 8.70536 2.38205 8 3.07847C7.29464 2.38205 5.83036 1.1499 4.26786 1.1499C1.59821 1.1499 0 2.7124 0 5.32847C0 7.47133 1.96429 9.26597 2.03571 9.32847L7.60714 14.7035C7.71429 14.8106 7.85714 14.8642 8 14.8642Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  )
}

export default Heart
